import { Component, Input, OnChanges } from '@angular/core';
import { StaticData } from '../../../providers/static-data/static-data';
import { TranslateOfficePipe } from '../../../shared/pipes/translate-office-pipe';

@Component({
    templateUrl: 'plan-frequency-message.html',
    selector: 'plan-frequency-message',
    providers: [TranslateOfficePipe],
    standalone: false
})

export class PlanFrequencyMessage implements OnChanges {

  @Input() planType;

  message: any;
  constructor(
    private staticData: StaticData,
    private translateOfficePipe: TranslateOfficePipe
  ) {}

  ngOnChanges() {
    const translate = this.translateOfficePipe.transform('home');
    this.message = this.staticData.getPlanFrequencyMessages(this.planType, translate);
  }
}
